'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';

const navLinks = [
  { label: 'Soins', href: '#services' },
  { label: 'À propos', href: '#about' },
  { label: 'Réservation', href: '#booking' },
  { label: 'Infos', href: '#info' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-40 transition-all duration-500 ${
        scrolled
          ? 'bg-cream-100/95 backdrop-blur-md shadow-sm border-b border-cream-300/40'
          : 'bg-cream-100/70 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between gap-8">
        {/* Logo */}
        <a href="#hero" className="shrink-0">
          <Image
            src="/logo.png"
            alt="La Canopée de Christelle"
            width={684}
            height={228}
            className="h-11 w-auto"
            priority
          />
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-sans text-sm text-forest-dark hover:text-forest tracking-wide transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <a
          href="#booking"
          className="hidden md:inline-flex items-center bg-forest text-cream-100 font-sans text-sm px-5 py-2.5 rounded-full hover:bg-forest-dark transition-colors tracking-wide shrink-0"
        >
          Réserver
        </a>

        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col justify-center gap-1.5 w-8 h-8 cursor-pointer"
          aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
        >
          <span
            className={`block h-px w-6 bg-forest-dark transition-all duration-300 origin-center ${
              menuOpen ? 'rotate-45 translate-y-[7px]' : ''
            }`}
          />
          <span
            className={`block h-px w-6 bg-forest-dark transition-all duration-300 ${
              menuOpen ? 'opacity-0 scale-x-0' : ''
            }`}
          />
          <span
            className={`block h-px w-6 bg-forest-dark transition-all duration-300 origin-center ${
              menuOpen ? '-rotate-45 -translate-y-[7px]' : ''
            }`}
          />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          menuOpen ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <div className="bg-cream-50/98 backdrop-blur-md border-t border-cream-300/40 px-6 py-5 flex flex-col gap-4">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setMenuOpen(false)}
              className="font-sans text-forest-dark hover:text-forest transition-colors py-1"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#booking"
            onClick={() => setMenuOpen(false)}
            className="bg-forest text-cream-100 font-sans text-center px-5 py-3 rounded-full hover:bg-forest-dark transition-colors mt-2"
          >
            Réserver
          </a>
        </div>
      </div>
    </nav>
  );
}
